import React, { Dispatch, SetStateAction } from 'react';

const emptyFunction: any = () => {};
const AuthContext = React.createContext<[string | null, Dispatch<SetStateAction<string | null>>]>([localStorage.getItem('token'), emptyFunction]);

export default AuthContext;